var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeroThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8498 5.09052V1.08014H8.15011V5.09052H0.65625V29.7676H29.3437V5.09052H21.8498ZM9.37957 2.3096H20.6204V5.1198H9.37957V2.3096ZM8.15011 6.31999H28.1728V13.9017H17.4296V10.5938H12.5703V13.9017H1.88571V6.31999H8.15011ZM16.2294 11.7647V17.1802H13.7705V11.7647H16.2294ZM1.88571 28.5381V15.1019H12.5703V18.4097H17.4296V15.1019H28.1728V28.5381H1.88571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeroThree);
export default __webpack_public_path__ + "static/media/IconHeroThree.4fbcb464f2e8cafe441cdd592ed97705.svg";
export { ForwardRef as ReactComponent };